@if (subscription) {
<div class="card card-nb subscription h-100 rounded-4" [ngClass]="{ 'hover-effect': canShowDetails }">
  <div class="card-body pb-0 rounded-4" [ngClass]="withBorder ? 'card-b-default' : ''" (click)="showDetails()">
    <div class="d-flex align-items-start justify-content-between mb-2">
      <div class="d-flex flex-row align-items-start">
        <div>
          <i [ngClass]="subscription.typeIcon" class="fa icon-size-bigger mr-2"></i>
        </div>
        <div class="d-flex flex-column">
          <div class="title">
            @if (showSubscriptionDetailLink) {
            <a class="btn-link" [routerLink]="['/subscriptions', subscription.appliance_id]">
              <app-subscription-title [subscription]="subscription"></app-subscription-title>
            </a>
            }
            @if (!showSubscriptionDetailLink) {
            <app-subscription-title [subscription]="subscription"></app-subscription-title>
            }
          </div>
          <span class="subinformations">{{ subscription.customer_name }}</span>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end">
        @if (showUpgradeBtn) {
          <div class="d-flex flex-row align-items-center cursor-pointer mr-3" (click)="upgradeIntegrationAppInstallation(subscription.appliance_id, installedVersion)">
            <i class="fa fa-arrow-up red fa-lg mr-1"></i>
            <span class="subinformations red">{{ 'subscription-card_upgrade_btn_text' | i18next }}</span>
          </div>
        }
        @if (showRetryBtn) {
          <div class="d-flex flex-row align-items-center cursor-pointer mr-3" (click)="retryAction(subscription.appliance_id)">
            <i class="fa fa-repeat red mr-1"></i>
            <span class="subinformations red">{{ 'subscription-card_retry_btn_text' | i18next }}</span>
          </div>
        }
        @if (installationState) {
          <div class="d-flex flex-row align-items-center mr-3">
            <span style="color: #faab00">{{ integrationService.getInstallationStateLabelKey(installationState) | i18next }}</span>
          </div>
        }
        <div class="d-flex align-items-center justify-content-end">
          @if (subscription.is_one_nfr) {
          <span class="badge badge-success">{{ 'nfr_one_label' | i18next }}</span>
          }
          @if (subscription.isDemoSystem) {
          <span class="badge badge-success ml-2">{{ 'demo_system_label' | i18next }}</span>
          }
          @if (subscription.isAvailabilityPremium) {
          <span class="badge badge-warning ml-2">{{ 'availability_premium' | i18next }}</span>
          }
          @if (subscription.isAvailabilityBeta) {
          <span class="badge badge-info ml-2">{{ 'availability_beta' | i18next}}</span>
          }
        </div>
        @if (showMenu) {
          <ng-content select="[titlemenu]"></ng-content>
        }
      </div>
    </div>
    <hr>
    <div class="row subinformations" style="min-height: 100px;">
      @if (!subscription.isOneTrial) {
      <div class="col-12 p-0 m-0"
        [innerHTML]="'subscription_concurrent_users' | i18next: { licType: licTypeName, userNumber: subscription.users }">
      </div>
      }
      @if (subscription.isNonPascomOneLicenseType && subscription.isCancelled) {
      <div class="mt-2 red">
        {{'subscription_cancelled' | i18next}}&nbsp;{{subscription.end_date | localized_date}}
      </div>
      }
      @if (isOneAndCancelled) {
      <div class="mt-2 red">
        {{ (subscription.isOneExpired ? 'pascom_one_expired_on' : 'pascom_one_expires_on') | i18next }}
        {{ subscription.end_date | localized_date }}
      </div>
      }
      @if (!subscription.isCancelled && subscription.next_invoice && !subscription.isOneTrial) {
      <div class="col-12 col-sm-10 p-0 m-0">
        @if (subscription.isNonPascomOneLicenseType && subscription.isCancelled) {
        <div class="red">
          <span class="text-nowrap">{{'subscription_cancelled' | i18next}}</span>
          <span class="ml-2">{{subscription.end_date | localized_date}}</span>
        </div>
        }
        @if (isOneAndCancelled) {
        <div class="red">
          <span class="text-nowrap">{{(subscription.isOneExpired ? 'pascom_one_expired_on' : 'pascom_one_expires_on') |
              i18next}}</span>
          <span class="ml-2">{{subscription.end_date | localized_date }}</span>
        </div>
        }
        @if (!subscription.isCancelled && subscription.next_invoice && !subscription.isOneTrial) {
        <div class="row">
          <div class="col-auto p-0 m-0" style="min-width: 180px;">
            <div class="text-nowrap">{{'subscription_next_invoice' | i18next}}</div>
          </div>
          <div class="col-auto p-0 m-0">
            <div>{{subscription.next_invoice | localized_date}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto p-0 m-0" style="min-width: 180px;">
            <div class="text-nowrap">{{'subscription_minimum_term_until' | i18next}}</div>
          </div>
          <div class="col-auto p-0 m-0">
            <div>{{subscription.nextPossibleEndDate | localized_date}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto p-0 m-0" style="min-width: 180px;">
            <div class="text-nowrap">{{'subscription_start_date' | i18next}}</div>
          </div>
          <div class="col-auto p-0 m-0">
            <div>{{subscription.startDate | localized_date}}</div>
          </div>
        </div>
        }
      </div>
      }
      @if (subscription.isOneTrial && subscription.isValid && !subscription.isDemoSystem) {
      <div class="mt-2 text-wrap">
        <div class="text-nowrap red">{{'pascom_one_trial_days_left' | i18next:{daysLeft: subscription.trialDaysLeft}
          }}</div>
      </div>
      }
      @if (subscription.isOneTrial && !subscription.isValid) {
      <div class="mt-2 text-wrap">
        <div class="text-nowrap red">{{'pascom_one_expired_on' | i18next:{date: subscription.end_date |
          localized_date, interpolation: { escapeValue: false } } }}</div>
      </div>
      }
      @if (subscription.trunks.length > 0) {
      <div class="mt-2 text-wrap">
        <div class="text-nowrap">{{'subscription_trunks' | i18next}}:</div>
        <div class="d-flex">
          @for (trunk of subscription.trunks; track trunk) {
          <span class="badge mr-2 badge-success">{{ trunk }}</span>
          }
        </div>
      </div>
      }
    </div>
    <div class="d-flex justify-content-between">
      <div class="d-flex ml-auto align-items-start">
        <ng-content></ng-content>
        @if (canUpgradeAfterExpired) {
        <ng-content select="[upgrade]"></ng-content>
        }
      </div>
    </div>
  </div>
  @if (status) {
  <div class="row subinformations pb-1 mr-2">
    <div class="d-flex ml-auto align-items-end flex-column mt-auto">
      @if (status.status !== 'api_loading') {
      <div class="mt-auto" style="min-height: 22px;">
        <span class="mr-2 status-text" [ngClass]="status.color">
          {{ status.status | i18next }}
        </span>
        <span>
          <i class="fas fa-info-circle red" [pTooltip]="status.status + '_tooltip' | i18next"
            [tooltipEvent]="deviceService.tooltipEvent" tabindex="0"></i>
        </span>
      </div>
      }
      @if (status.status === 'api_loading') {
      <div class="mt-auto" style="min-height: 22px;">
        <img src="assets/images/loading.gif" height="16px" alt="Loading content">
      </div>
      }
    </div>
    
  </div>
  }
  @if (status && status.status !== 'api_loading') {
  <div class="m-0 pt-2 status-bg" [ngClass]="status.color">
  </div>
  }
</div>
}